import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { templates, defaultPattern, getPatternStyle } from './templates';
import './styles/pages.css';
import './styles/templates.css';

const Preview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { templateId, question, cta, pattern = defaultPattern } = location.state || {};

  const [showCta, setShowCta] = useState(false);

  const template = templates[templateId];

  if (!template || !question || !cta) {
    navigate('/Playground/Inviteapp/templates');
    return null;
  }

  const TemplateComponent = template.component;

  const handleYes = () => {
    setShowCta(true);
  };

  const handleSend = () => {
    navigate('/Playground/Inviteapp/send', {
      state: { templateId, question, cta, pattern },
    });
  };

  const handleDiscard = () => {
    if (window.confirm('Are you sure you want to discard this invite?')) {
      navigate('/Playground/Inviteapp/templates');
    }
  };

  const handleReset = () => {
    setShowCta(false);
  };

  return (
    <div className="preview-page">
      <div className="preview-header">
        <h2>Preview Your Invite {'\uD83D\uDC40'}</h2>
        <p>Try hovering over the "No" button!</p>
      </div>

      <div className="preview-container">
        <div className="phone-frame">
          <div className="phone-notch" />
          <div className="phone-screen">
            <TemplateComponent
              question={question}
              cta={cta}
              onYes={handleYes}
              showCta={showCta}
              patternStyle={getPatternStyle(pattern, template.colors.primary)}
              preview={template.preview}
              name={template.name}
            />
          </div>
        </div>
      </div>

      {showCta && (
        <motion.button
          className="reset-preview"
          onClick={handleReset}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {'\uD83D\uDD04'} Reset Preview
        </motion.button>
      )}

      <div className="preview-actions">
        <motion.button
          className="discard-button"
          onClick={handleDiscard}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          {'\uD83D\uDDD1\uFE0F'} Discard
        </motion.button>
        <motion.button
          className="send-button"
          onClick={handleSend}
          style={{
            background: `linear-gradient(135deg, ${template.colors.primary}, ${template.colors.secondary})`,
          }}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          Send Invite {'\uD83D\uDC8C'}
        </motion.button>
      </div>
    </div>
  );
};

export default Preview;
